@if (order) {
  <div class="card card-nb h-100 order" (click)="downloadAttachment()">
    <div class="card-body pb-0">
      <div class="d-flex justify-content-between">
        <div class="p-0 m-0 font-weight-bold">
          <span>{{order.name}}&nbsp;</span>
        </div>
        @if (isPartnerOrder && order.state === 'sent' && !order.expired) {
          <div class="custom-dropdown-menu ml-3" ngbDropdown display="dynamic" placement="bottom-right">
            <div class="btn bg-transparent p-0 m-0 hide-dropdown-icon" id="dropdownBasic2" ngbDropdownToggle>
              <i class="fas fa-ellipsis-v red icon-size-bigger navbar-profile-icon"></i>
            </div>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
              <div class="cursor-pointer dropdown-item" (click)="resendQuotation()">
                <span class="d-flex">
                  <i class="fa fa-backward red icon-size-big mr-2"></i>
                  <span>{{ 'resend_quotation' | i18next }}</span>
                </span>
              </div>
              <div class="cursor-pointer dropdown-item" (click)="cancelQuotation()">
                <span class="d-flex">
                  <i class="fa fa-ban red icon-size-big mr-2"></i>
                  <span>{{ 'cancel_quotation' | i18next }}</span>
                </span>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="subinformations">
        <div class="d-flex flex-column flex-sm-row justify-content-between">
          <div class="p-0 m-0">
            <div class="d-flex align-items-center align-self-center">
              <i class="far fa-user red"></i>
              <div class="ml-1">{{order.customer_name}}@if (order.appliance_id) {
                <span></span>
              }</div>
            </div>
            <div>
              @if (order.appliance_id && order.appliance_name) {
                @if (isRelevantProduct(order.product)) {
                  [<a routerLink="/subscriptions/{{order.appliance_id}}">{{order.appliance_id}}</a>] {{order.appliance_name}}
                } @else {
                  [{{order.appliance_id}}] {{order.appliance_name}}
                }
              }
            </div>
          </div>
          <div>{{order.date | localized_date}}</div>
        </div>
      </div>
      <div class="subinformations mt-3">
        <div class="d-flex flex-column">
          <div class="d-flex flex-column flex-sm-row justify-content-between">
            @if (order.product) {
              <div class="p-0 m-0">
                {{ order.quantity }} x {{ order.getProductNameForPreview() }}
              </div>
            }
            <div class="text-nowrap font-weight-bold"> {{order.amount_untaxed | localized_currency}}</div>
          </div>
          <div class="d-flex flex-row-reverse ml-auto p-0 m-0 mt-2">
            @if (order.attachment) {
              <i
                class="dlbutton fas fa-download features-icon red icon-size-bigger "
                style="cursor: pointer">
              </i>
            }
          </div>
        </div>
      </div>
    </div>
    @if (isPartnerOrder) {
      <div class="row subinformations pb-1 mr-2">
        <div class="d-flex ml-auto align-items-end flex-column mt-auto">
          <div class="mt-auto" style="min-height: 22px;">
            <span [class]="cssClass" class="mr-2 status-text">
              @if (cssClass.active ) {
                <span>{{ 'quotation_status_active' | i18next }}</span>
              }
              @if (cssClass.dead) {
                <span>{{ 'quotation_status_expired' | i18next }}</span>
              }
              @if (cssClass.pending && order.state === 'sent' && state === 'sent') {
                <span>{{ 'quotation_status_customer_approval' | i18next }}</span>
              }
              @if (cssClass.pending && order.state === 'sale' && state === 'sent') {
                <span>{{ 'quotation_status_pending_approval' | i18next }}</span>
              }
            </span>
          </div>
        </div>
      </div>
    }
    @if (isPartnerOrder) {
      <div  class="m-0 pt-1 status-bg" [class]="cssClass" ></div>
    }
  </div>
}
